module.exports = __webpack_public_path__ + "img/Polycom_8800.06ff2953.png";